import { CheckCircle, AlertCircle, Clock, Loader } from 'lucide-react';
import type { Job } from './types';

// Status -> icon. Shared by JobDetailPage, JobsPage, DataSourceDetailPage
// and the in-progress chip in Layout's header so the
// visual vocabulary stays consistent.
export function JobStatusIcon({ status, className = 'w-5 h-5' }: {
    status: Job['status'];
    className?: string;
}) {
    switch (status) {
        case 'success': return <CheckCircle className={`${className} text-state-success`} />;
        case 'failed': return <AlertCircle className={`${className} text-state-error`} />;
        case 'pending':
        case 'queued': return <Clock className={`${className} text-signal`} />;
        default: return <Loader className={`${className} text-brand animate-spin`} />;
    }
}

export function jobStatusBgColor(status: Job['status']): string {
    switch (status) {
        case 'success': return 'bg-state-success/15';
        case 'failed': return 'bg-state-error/15';
        case 'pending':
        case 'queued': return 'bg-signal/15';
        default: return 'bg-brand/15';
    }
}
